import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createSupplier } from "../../api/apiSuppliers";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const useCreateSupplier = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: createSupplierMutate, isPending } = useMutation({
        mutationFn: createSupplier,
        onSuccess: (res) => {
            toast.success(res.message || "Supplier created successfully");
            queryClient.invalidateQueries({ queryKey: ["suppliers"] });
            navigate("/suppliers");
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to create supplier");
        },
    });

    return { createSupplierMutate, isPending };
};

export default useCreateSupplier;
